import React from "react"
import Cookie from "../models/Cookie"
import LocaleLanguages from "../enum/LocaleLanguages";

const user: {
  nickname: string,
  hash: string,
  balance: number,
  setBalance: (balance: number) => void,
  language: LocaleLanguages
} = {
  nickname: Cookie.getNickname(),
  hash: Cookie.getPlayerHash(),
  balance: Cookie.getBalance(),
  setBalance: (balance: number) => Cookie.setBalance(balance),
  language: Cookie.getLanguage(),
}

const UserContext = React.createContext(user)

export default UserContext